import {useSearchParams} from "react-router-dom";
import {getDetailProject, postDuplicateProject, postNameProject} from "../../../api/project/project.api";
import {Button, CoinIcon, MouseIcon, Panel, ProjectIcon, Tab, Tag, TextInput, UserIcon} from "omoplay";
import {useEffect, useState} from "react";
import ProjectDetailSummary from "./ProjectDetailSummary";
import GraphStatistics from "../GraphStatistics";
import EntryPointStatistics from "../EntryPointStatistics";
import BenefitStatistics from "../BenefitStatistics";
import QuantitySettings from "./QuantitySettings";
import EditPenIcon from "../../../assets/images/icon.edit.svg"
import RevisitSettings from "./RevisitSettings";
import { ReactComponent as ArrowLeft } from "../../../assets/images/arrrow-left.svg";
import SurveyStatistics from "../SurveyStatistics";

export const ProjectDetail = () => {
  const [query] = useSearchParams();
  const [project, setProject] = useState({})
  const [tab, setTab] = useState("summary")
  const [isEditName, setIsEditName] = useState(false)
  const [editProjectName, setEditProjectName] = useState("")
  const id = query.get("id")
  const tabItems = [
    { label: "개요", value: "summary", selected: true},
    { label: "수량 설정", value: "quantity"},
    { label: "혜택 성과", value: "benefitStatistics"},
    { label: "고객 분석", value: "userStatistics"},
    { label: "진입점 분석", value: "entryPointStatistics"},
    { label: "설문조사 분석", value: "surveyStatistics"},
    //{ label: "재방문 이벤트", value: "revisit"}
  ]

  /*
    페이지(창) 스크롤바를 이 화면에서만 보이게 한다(2026-10-06 사용자 요청).

    `common.css` 의 전역 `::-webkit-scrollbar { display: none }` 이 **창 스크롤바까지** 숨긴다.
    이 화면은 '설문조사 분석' 처럼 탭 내용이 길어 맨 아래까지 한 번에 끌어 내릴 손잡이가 필요하다.
    `<body>`·`<html>` 에 `.scrollbar-always`(항상 보이는 12px 스크롤바, 같은 파일)를 붙였다가 화면을 떠날 때 뗀다.

    🔴 **`<body>` 가 핵심이다**(2026-10-06 로컬 신고로 정정). Chromium 은 창 스크롤바 모양을 `<html>` 이 아니라
       `<body>` 의 `::-webkit-scrollbar` 에서 가져온다 — 헤드리스 실측: html 에만 붙이면 0px, body 에 붙이면 12px.
       `<html>` 은 그 규칙을 따르지 않는 브라우저 대비로 같이 붙인다.
    ⚠️ 전역 규칙은 그대로 둔다 — 지우면 앱의 모든 스크롤 영역 모양이 한꺼번에 바뀐다(같은 파일 주석).
  */
  useEffect(() => {
    const targets = [document.documentElement, document.body]
    targets.forEach(el => el.classList.add("scrollbar-always"))
    return () => targets.forEach(el => el.classList.remove("scrollbar-always"))
  }, [])

  useEffect(() => {
    getDetailProject(id).then(({data}) => {
        setProject(data)
        setEditProjectName(data.name)
    })
  }, [id, tab])

  const tabRender = () => {
    if (tab === "summary") {
        return <ProjectDetailSummary projectId={id} project={project}
                                     passwordType={project.passwordType}
                                     benefitPassword={project.benefitPassword} />
    } else if (tab === "quantity") {
        return <QuantitySettings projectId={id} />
    } else if (tab === "benefitStatistics") {
        return <BenefitStatistics projectId={id} />
    } else if (tab === "userStatistics") {
        return <GraphStatistics periodStartDate={project.startDate} projectId={id} />
    } else if (tab === "entryPointStatistics") {
        return <EntryPointStatistics periodStartDate={project.startDate} projectId={id} />
    } else if (tab === "surveyStatistics") {
        return <SurveyStatistics periodStartDate={project.startDate} projectId={id} />
    } else if (tab === "revisit") {
        return <RevisitSettings projectId={id} />
    }
  }

  return (
      <div className="flex-col gap-4">
        <div className="flex-align-center gap-2">
          <div><Tag color={project.badgeColor} >{project.statusKor}</Tag></div>
          <div className="text-grey-7">{project.period}</div>
        </div>
        <div>
          <div className="flex gap-4 items-center mb-2">
            <div className="bg-white" style={{borderRadius: "6px"}}>
              <Button variants="outlined"
                      style={{width: "40px"}}
                      onClick={() => window.location.href = ("/project")}
                      value={<ArrowLeft />}
              />
            </div>
            {
              isEditName ? (
                  <div>
                    <TextInput value={editProjectName}
                               onChange={(e) => setEditProjectName(e.target.value)}
                               onKeyUp={(e) => {
                                 if (e.key === "Enter") {
                                   postNameProject(project.id, editProjectName).then(() => {
                                     project.name = editProjectName
                                     setIsEditName(false)
                                   })
                                 } else if (e.key === "Escape") {
                                   setIsEditName(false)
                                 }
                               }}
                    />
                  </div>
              ) : (<h4 className="font-extrabold" style={{fontSize: "28px"}}>{project.name}</h4>)
            }
            <div className="pointer" onClick={() => {
              if (isEditName) {
                postNameProject(project.id, editProjectName).then(() => {
                  project.name = editProjectName
                  setIsEditName(false)
                })
              } else {
                setIsEditName(true)
              }
            }}>
              <img alt="" src={EditPenIcon} />
            </div>
              <div>
                  <Button variants="secondary" value="복제하기" onClick={() => {
                      if (window.confirm("해당 프로젝트를 복제하시겠습니까?\n프로젝트 중복 불가 설정은 복제되지 않습니다.")) {
                          postDuplicateProject(project.id).then(() => {
                              window.location.href = "/project"
                          })
                      }
                  }} />
              </div>
          </div>
          <div className="flex-col gap-20 mt-8 bg-white">
            <Panel items={[
              {
                title: (
                    <>
                      <div className='panel-icon'>
                        <ProjectIcon />
                      </div>
                      <p>프로젝트</p>
                    </>
                ),
                value: (project.days >= 0 ? `${project.days + 1}일차` : `D-${Math.abs(project.days)}일`),
                suffix:
                    (project.remainDays !== null && project.remainDays >= 0) ? (
                        <div style={{fontSize: "24px"}}>
                          ({project.remainDays}일 남음)
                        </div>
                    ) : <></>,
              },
              {
                title: (
                    <>
                      <div className='panel-icon'>
                        <UserIcon />
                      </div>
                      <p>참여 고객</p>
                    </>
                ),
                value: project.joinUserNum?.toLocaleString(),
                suffix: '명',
              },
              {
                title: (
                    <>
                      <div className='panel-icon'>
                        <MouseIcon />
                      </div>
                      <p>노출 수</p>
                    </>
                ),
                value: project.totalViews?.toLocaleString(),
                suffix: '회',
              },
              {
                title: (
                    <>
                      <div className='panel-icon'>
                        <CoinIcon />
                      </div>
                      <p>마케팅 비용</p>
                    </>
                ),
                value: project.totalMarketingPrice?.toLocaleString(),
                suffix: '원',
              },
            ]} />
          </div>
        </div>
        <div className="flex-col gap-4 pt-[24px]">
          <div style={{width: "100%"}}>
            <Tab variants="default"
                 items={tabItems}
                 onChanged={(item) => {
                     setTab(item.value)
                 }}
                 style={{gap: "4px"}}
            />
          </div>
          <div>
            {
              tabRender()
            }
          </div>
          <div style={{height: "60px"}}></div>
        </div>
      </div>
  );
};
export default ProjectDetail;
